'use strict';
/**
 * @doc module
 * @name util
 * @description
 *
 * util factory.
 */

var app = angular.module('harriApp');


/**
 * This factory using for share data between controller in AMS
 */
app.factory('amsBus', function(){
    var handlers = {
        "AMSInitialized": [],
        "onSSExit": [],
        "onFastDeferLoad": [],
    }


    var bus = {
        'onAMSInitialized': function(handler) {
            if(this['isAMSInitialized']){
                handler(this['_AMSDataManager'], this['_AMSActions'], this['_AMSRenderHelper']);
            }

            handlers["AMSInitialized"].push(handler);
        },
        'onSSExit': function(handler) {
            handlers["onSSExit"].push(handler);
        },
        'onFastDeferLoad': function(handler) {
            handlers["onFastDeferLoad"].push(handler);
        },
        'fireFastDeferLoad': function (data) {
            handlers["onFastDeferLoad"].forEach(function (handler) {
                // Separate context
                (function () {
                    handler(data);
                })();
            });
        },
        'fireAMSInitialized': function(amsDataManager, amsActions, amsRenderHelper) {

            this['_AMSDataManager'] = amsDataManager;
            this['_AMSActions'] = amsActions;
            this['_AMSRenderHelper'] = amsRenderHelper;

            this['isAMSInitialized'] = true;
            handlers["AMSInitialized"].forEach(function(handler) {
                // Separate context
                (function(){
                    handler(amsDataManager, amsActions, amsRenderHelper);
                })();
            });
        },
        'fireSSExit':function(){
           handlers["onSSExit"].forEach(function(handler) {
                // Separate context
                (function(){
                    handler();
                })();
            });
        },
        'isAMSInitialized': false,
        'reset': function() {
            this['_AMSDataManager'] = null;
            this['_AMSActions'] = null;
            this['isAMSInitialized'] = false;
            handlers["AMSInitialized"] = [];
            handlers["fireFastDeferLoad"] = [];
            handlers["onSSExit"] = [];
        }
    };

    return bus;
});